/*
* Hook Add quantity controls -/+
*/
document.addEventListener("DOMContentLoaded", pdw_wc_qty_init);
jQuery(document.body).on("wc_fragments_refreshed", pdw_wc_qty_init);
jQuery(document.body).on("wc_fragments_ajax_error", pdw_wc_qty_init);
jQuery(document.body).on("wc_fragment_refresh", pdw_wc_qty_init);
jQuery(document.body).on("wc_fragments_loaded", pdw_wc_qty_init);
jQuery(document.body).on("update_checkout", pdw_wc_qty_init);
jQuery(document.body).on("updated_wc_div", pdw_wc_qty_init);
jQuery(document.body).on("applied_coupon", pdw_wc_qty_init);
jQuery(document.body).on("removed_coupon", pdw_wc_qty_init);

/*
* Hook Refresh WooCommerce Ajax Fragment
*/
//Fix minicart count with wp-rocket
document.addEventListener("DOMContentLoaded", pdw_wc_fragment_refresh);
document.addEventListener("load", pdw_wc_fragment_refresh);
jQuery(document.body).on("added_to_cart", pdw_wc_fragment_refresh);

/*
* Hook on ajax add to cart
*/
jQuery(document.body).on("added_to_cart", pdw_wc_open_cart);

/*
* Add quantity controls -/+
 */
function pdw_wc_qty_init() {
    let inputQuantities = document.querySelectorAll('.quantity');
    inputQuantities.forEach((el) => {
        let inputQty = el.querySelector('input.qty');
        let qtyDown = document.createElement('span');
        let qtyUp = document.createElement('span');
        qtyDown.addEventListener('click', (el) => {
            inputQty.stepDown();
            inputQty.dispatchEvent(new window.Event('change', {bubbles: true}));
            document.querySelector('button[name="update_cart"]').click();
        });
        qtyDown.classList.add('pdw-wc-qty-down');
        qtyUp.addEventListener('click', (el) => {
            inputQty.stepUp();
            inputQty.dispatchEvent(new window.Event('change', {bubbles: true}));
            document.querySelector('button[name="update_cart"]').click();
        });
        qtyUp.classList.add('pdw-wc-qty-up');
        el.appendChild(qtyDown);
        el.appendChild(qtyUp);
    });
}

/*
* Open minicart
*/
function pdw_wc_open_cart() {
    document.querySelectorAll('.pdw-wc-minicart-link')[0].click();
}

/*
* Refresh WooCommerce Ajax Fragment
*/
function pdw_wc_fragment_refresh(ev) {
    jQuery(document.body).trigger('wc_fragment_refresh');
}